import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import PropTypes from "prop-types";
// import WebViewer from '@pdftron/webviewer'

// Custom Component
import useLoading from "../../Loading/useLoading";
import RFIInboxList from "././RFIInboxList";
import RFIDetailsForm from "././RFIDetailsForm";
import FullScreenDialog from "../../Dialog/FullScreenDialog";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import { Alert } from "../../Alert/Alert";
// Custom Style
import { rfiStyle } from "../../../styles/jss/components/RFI/rfiStyle";

const useStyles = makeStyles((theme) => rfiStyle(theme));
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `submission-tab-${index}`,
    "aria-controls": `submission-tabpanel-${index}`,
  };
};

const RFI = (props) => {
  const [tabValue, setTabValue] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const userCategoryCode = store.get("user_category_code") || "";
  const isShowCreateBtn =
    userCategoryCode === "SUPPLIER" ||
    userCategoryCode === "SUBCON" ||
    userCategoryCode === "SANFIELD";
  const isSubCon =
    userCategoryCode === "SUPPLIER" || userCategoryCode === "SUBCON";
  const isInternal = userCategoryCode === "SANFIELD";

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 1) {
      setOpenDialog(true);
    }
  };

  // Build Alert
  const buildAlert = (data) => {
    setAlertData({
      type: data.type,
      title: data.title,
      content: data.content,
    });
    setAlertOpen(true);
  };

  const newRfiDialogTitle = `New ${isSubCon ? "Draft " : ""}RFI`;

  return (
    <Fragment>
      <Alert
        open={alertOpen}
        alertType={alertData.type}
        alertTitle={alertData.title}
        alertContent={alertData.content}
        handleClose={() => setAlertOpen(false)}
      />
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="rfi tabs "
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="RFI Inbox" {...a11yProps(0)} />
            {isShowCreateBtn && (
              <Tab label="Create New RFI" {...a11yProps(1)} />
            )}
          </Tabs>
        </AppBar>
        <TabPanel value={tabValue} index={0}>
          {<RFIInboxList buildAlert={buildAlert} />}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <FullScreenDialog
            open={openDialog}
            dialogTitle={newRfiDialogTitle}
            formContent={
              <RFIDetailsForm
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                buildAlert={buildAlert}
                isSubCon={isSubCon}
                isInternal={isInternal}
                isNew={true}
                setTabValue={setTabValue}
              />
            }
            button={[]}
            handleClose={() => {
              setOpenDialog(false);
              setTabValue(0);
            }}
          ></FullScreenDialog>
        </TabPanel>
      </div>
    </Fragment>
  );
};

export default RFI;
